import { Typography } from '@mui/material'
import { useContext, useState } from 'react'

import { AppSettingsContext } from '../../Contexts'
import { Property, PropertyAction } from '../../Properties'

const DeveloperModeProperty: React.FC = () => {
  const { developerMode, enableDeveloperMode } = useContext(AppSettingsContext)
  const [clickString, setClickString] = useState('')

  const checkString = (clickString: string) => {
    setClickString(clickString)
    if (clickString === '123212321') {
      enableDeveloperMode?.(!developerMode)
      setClickString('')
    }
  }

  const onClick1 = () => {
    checkString(clickString + '1')
  }

  const onClick2 = () => {
    checkString(clickString + '2')
  }

  const onClick3 = () => {
    checkString(clickString + '3')
  }

  const action1: PropertyAction = {
    name: '1',
    onClick: onClick1,
  }
  const action2: PropertyAction = {
    name: '2',
    onClick: onClick2,
  }
  const action3: PropertyAction = {
    name: '3',
    onClick: onClick3,
  }

  return (
    <Property actions={[action1, action2, action3]} title="Developer Mode" value={developerMode}>
      <Typography variant="caption">{developerMode ? 'Enabled' : 'Disabled'}</Typography>
    </Property>
  )
}

export default DeveloperModeProperty
